import { render, staticRenderFns } from "./DataSourceAttributesEditing.vue?vue&type=template&id=7d4187e6&scoped=true&"
import script from "./DataSourceAttributesEditing.vue?vue&type=script&lang=js&"
export * from "./DataSourceAttributesEditing.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceAttributesEditing.vue?vue&type=style&index=0&id=7d4187e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4187e6",
  null
  
)

export default component.exports